import api from '@/api/index.js'

const audit_log = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_AUDIT_LOG_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_AUDIT_LOG: (state, data) => {
      state.data = data
      state.loading = false
    },
    SET_AUDIT_LOG_ERROR: (state, error) => {
      state.error = error
      state.loading = false
    }
  },

  actions: {
    GetAuditLog({commit}, query) {
      commit('SET_AUDIT_LOG', null)
      commit('SET_AUDIT_LOG_ERROR', null)
      commit('SET_AUDIT_LOG_LOADING', true)

      let queryPath = `audit-logs/${query.id}`;

      return api.get(queryPath)
        .then((response) => {
          commit('SET_AUDIT_LOG', response)
          commit('SET_AUDIT_LOG_ERROR', null)
        })
        .catch((error) => {
          commit('SET_AUDIT_LOG_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.url + ': ' + error.bodyText)
        })
    }
  },
}

export default audit_log
